import { useEffect, useState } from 'react';

import * as api from 'api/methods';

import { useFetch } from 'hooks/useFetch';

export const useInboxCount = (userId: string) => {
  const [count, setCount] = useState({
    lessonsRatingsCount: 0,
    lessonsReportsCount: 0,
    studentReviewCount: 0,
    unsibscribeReasonsCount: 0,
    surveysCount: 0,
  });

  const { loading: ratingsLoading, data: lessonsRatings } = useFetch(
    {
      defaultData: {
        data: [],
      },
      fetcher: api.getLessonsRatingsByStudentId,
      immediately: false,
      stopRequest: false,
    },
    {
      studentId: userId,
      params: { sortBy: 'createdAt', sortDirection: 'desc' },
    },
    [],
  );

  const { loading: reviewsLoading, data: studentsReviews } = useFetch(
    {
      defaultData: {
        data: [],
      },
      fetcher: api.getStudentReviewsByStudentId,
      immediately: false,
      stopRequest: false,
    },
    {
      studentId: userId,
      params: { sortBy: 'createdAt', sortDirection: 'desc' },
    },
    [],
  );

  const { loading: reportsLoading, data: lessonsReports } = useFetch(
    {
      defaultData: {
        data: [],
      },
      fetcher: api.getLessonsReportsByStudentId,
      immediately: false,
      stopRequest: false,
    },
    {
      studentId: userId,
      params: { sortBy: 'createdAt', sortDirection: 'desc' },
    },
    [],
  );

  const { loading: loadingReasons, data: reasons } = useFetch(
    {
      defaultData: {
        data: [],
      },
      fetcher: api.getStudentUnsubscribeReasonsByStudentId,
      immediately: false,
      stopRequest: false,
    },
    {
      studentId: userId,
      params: {
        sortBy: 'createdAt',
        sortDirection: 'desc',
      },
    },
    [],
  );

  const { loading: loadingSurveys, data: surveys } = useFetch(
    {
      defaultData: {
        data: [],
      },
      fetcher: api.getSurveysByStudentId,
      immediately: false,
      stopRequest: false,
    },
    {
      studentId: userId,
      params: {
        sortBy: 'createdAt',
        sortDirection: 'desc',
      },
    },
    [],
  );

  const loading =
    reportsLoading ||
    loadingReasons ||
    ratingsLoading ||
    reviewsLoading ||
    loadingSurveys;

  useEffect(() => {
    if (!loading) {
      setCount({
        lessonsRatingsCount: lessonsRatings.totalItems,
        lessonsReportsCount: lessonsReports.totalItems,
        studentReviewCount: studentsReviews.totalItems,
        unsibscribeReasonsCount: reasons.totalItems,
        surveysCount: surveys.totalItems,
      });
    }
  }, [loading]);

  return [
    loading,
    count.lessonsRatingsCount,
    count.lessonsReportsCount,
    count.studentReviewCount,
    count.unsibscribeReasonsCount,
    count.surveysCount,
  ];
};
